import { render, staticRenderFns } from "./JobResultSkeleton.vue?vue&type=template&id=0160d20d&lang=pug&"
import script from "./JobResultSkeleton.vue?vue&type=script&lang=ts&"
export * from "./JobResultSkeleton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0160d20d')) {
      api.createRecord('0160d20d', component.options)
    } else {
      api.reload('0160d20d', component.options)
    }
    module.hot.accept("./JobResultSkeleton.vue?vue&type=template&id=0160d20d&lang=pug&", function () {
      api.rerender('0160d20d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/job-components/JobResultSkeleton.vue"
export default component.exports